import { render } from "./completed-coach.vue?vue&type=template&id=c3080262"
import script from "./completed-coach.vue?vue&type=script&lang=js"
export * from "./completed-coach.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__